<template>
    <div>
        <config-main-title> Promedsys </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-9">
                <AzPeriodo v-model="filtros" :sync="true" @sync="sincronizarPeriodo" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-primary" @click="abrir_modal_executar()">
                    <i class="fas fa-play mr-1"></i> Executar
                </button>
            </div>
        </div>

        <div v-if="lista && lista_filtrada.length > 0">
            <div class="list-group mb-3 az-anime-surgir">
                <li
                    class="list-group-item list-group-item-action"
                    v-for="(log, id) in lista_filtrada"
                    :key="id"
                    @click="editar_log(log)"
                    style="cursor: pointer;"
                >
                    <div class="d-flex align-items-start">
                        <!-- Status -->
                        <div class="mr-3 mt-1" style="min-width: 90px;">
                            <span class="badge badge-pill" :class="log.fl_sucesso ? 'badge-success' : 'badge-danger'">
                                <i :class="log.fl_sucesso ? 'fas fa-check' : 'fas fa-times'"></i>
                                {{ log.fl_sucesso ? 'Sucesso' : 'Erro' }}
                            </span>
                        </div>

                        <!-- Endpoint + erro/resumo -->
                        <div class="flex-grow-1 mr-3">
                            <div class="font-weight-bold text-dark">{{ log.st_endpoint }}</div>
                            <div v-if="!log.fl_sucesso && log.st_erro" class="text-danger small mt-1">
                                <i class="fas fa-exclamation-circle mr-1"></i>{{ log.st_erro }}
                            </div>
                            <div v-if="log.js_data && log.js_data.resumo" class="text-muted small mt-1">
                                <span class="mr-3"><i class="fas fa-inbox mr-1"></i>Recebidos: <strong>{{ log.js_data.resumo.qt_total_recebido }}</strong></span>
                                <span class="mr-3"><i class="fas fa-cogs mr-1"></i>Processados: <strong>{{ log.js_data.resumo.qt_processado }}</strong></span>
                                <span class="mr-3"><i class="fas fa-check-circle mr-1 text-success"></i>Atualizados: <strong>{{ log.js_data.resumo.qt_atualizado }}</strong></span>
                                <span v-if="log.js_data.resumo.qt_erro > 0" class="text-danger"><i class="fas fa-times-circle mr-1"></i>Erros: <strong>{{ log.js_data.resumo.qt_erro }}</strong></span>
                            </div>
                        </div>

                        <!-- Tipo -->
                        <div class="mr-3 mt-1 text-nowrap" style="min-width: 78px;">
                            <span
                                :class="log.js_data && log.js_data.envio ? 'text-warning' : 'text-info'"
                                style="font-size: 0.78rem;"
                            >
                                <i
                                    class="mr-1"
                                    :class="log.js_data && log.js_data.envio ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"
                                    :title="log.js_data && log.js_data.envio ? 'Envio' : 'Consulta'"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                ></i>
                                {{ log.js_data && log.js_data.envio ? 'Envio' : 'Consulta' }}
                            </span>
                        </div>

                        <!-- Datas -->
                        <div class="text-right text-nowrap" style="min-width: 210px;">
                            <div class="px-2 py-1 rounded" style="background-color: #e8f4fd; border-left: 3px solid #3a9bd5;">
                                <div class="small text-muted">Última consulta</div>
                                <div class="font-weight-bold" style="color: #1a6fa0; font-size: 0.95rem;">
                                    <i class="fas fa-clock mr-1"></i>{{ formatarData(log.dt_ultima_consulta) }}
                                </div>
                            </div>
                            <div class="small text-muted mt-1">
                                <i class="fas fa-calendar-alt mr-1"></i>Criado em: {{ formatarData(log.created_at) }}
                            </div>
                        </div>
                    </div>
                </li>
            </div>
        </div>

        <div v-else>
            <az-empty-state msg="Nenhum log encontrado..." icon="fas fa-file-alt" />
        </div>

        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
            <div class="d-flex">
                <paginate
                    class="mb-0"
                    :page-count="dados.last_page"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="recarregar"
                />
            </div>
        </nav>

        <div class="modal fade" id="modalExecutarPromedSys" tabindex="-1" role="dialog"
            aria-labelledby="modalExecutarPromedSysTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-play mr-2"></i>Executar Promedsys
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Data e hora de execução"
                                    type="datetime-local"
                                    required
                                    :validate="validate"
                                    v-model="execucao.dt_execucao"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Cancelar
                        </button>
                        <az-submit @click="confirmar_execucao()">
                            Confirmar
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalPromedSys" tabindex="-1" role="dialog"
            aria-labelledby="modalPromedSysTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Detalhes do Log
                            <span class="badge badge-secondary ml-2"># {{ item.id_promedsys_log }}</span>
                            <span class="badge badge-pill ml-2" :class="item.fl_sucesso ? 'badge-success' : 'badge-danger'">
                                {{ item.fl_sucesso ? 'Sucesso' : 'Erro' }}
                            </span>
                            <span
                                class="ml-2"
                                :class="item.js_data && item.js_data.envio ? 'text-warning' : 'text-info'"
                                :title="item.js_data && item.js_data.envio ? 'Envio' : 'Consulta'"
                                data-toggle="tooltip"
                                data-placement="top"
                                style="font-size: 0.75rem;"
                            >
                                <i class="mr-1" :class="item.js_data && item.js_data.envio ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"></i>
                                {{ item.js_data && item.js_data.envio ? 'Envio' : 'Consulta' }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- Cabeçalho fixo -->
                        <div class="row mb-3">
                            <div class="col col-12 col-md-6">
                                <label class="text-muted small mb-0">Endpoint</label>
                                <div class="font-weight-bold">{{ item.st_endpoint }}</div>
                            </div>
                            <div class="col col-12 col-md-3">
                                <label class="text-muted small mb-0">Criado em</label>
                                <div>{{ formatarData(item.created_at) }}</div>
                            </div>
                            <div class="col col-12 col-md-3">
                                <label class="text-muted small mb-0">Última consulta</label>
                                <div class="font-weight-bold">{{ formatarData(item.dt_ultima_consulta) }}</div>
                            </div>
                        </div>

                        <div v-if="!item.fl_sucesso && item.st_erro" class="alert alert-danger mb-3">
                            <i class="fas fa-exclamation-circle mr-2"></i>{{ item.st_erro }}
                        </div>

                        <div v-if="item.js_data && item.js_data.resumo" class="d-flex flex-wrap mb-3">
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Total recebido: <strong>{{ item.js_data.resumo.qt_total_recebido }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Processados: <strong>{{ item.js_data.resumo.qt_processado }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Encontrados: <strong>{{ item.js_data.resumo.qt_encontrado }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Atualizados: <strong>{{ item.js_data.resumo.qt_atualizado }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Erros: <strong>{{ item.js_data.resumo.qt_erro }}</strong>
                            </span>
                        </div>

                        <!-- Abas -->
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="tab-req-res" data-toggle="tab" href="#pane-req-res" role="tab">Request / Response</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="tab-data" data-toggle="tab" href="#pane-data" role="tab">Dados</a>
                            </li>
                        </ul>

                        <div class="tab-content pt-3">
                            <!-- Aba Request / Response -->
                            <div class="tab-pane fade show active" id="pane-req-res" role="tabpanel">
                                <div class="row">
                                    <div class="col col-12 col-md-6">
                                        <label class="text-muted small mb-1">Request</label>
                                        <pre class="bg-light p-2 rounded small" style="max-height: 300px; overflow-y: scroll;">{{ formatarJson(item.js_request) }}</pre>
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <label class="text-muted small mb-1">Response</label>
                                        <pre class="bg-light p-2 rounded small" style="max-height: 300px; overflow-y: scroll;">{{ formatarJson(item.js_response) }}</pre>
                                    </div>
                                </div>
                            </div>

                            <!-- Aba Dados (js_data) -->
                            <div class="tab-pane fade" id="pane-data" role="tabpanel">
                                <div class="mb-2">
                                    <az-input
                                        label="Pesquisar no JSON"
                                        v-model="buscaJsonDados"
                                        placeholder="Pesquisar..."
                                    />
                                    <div v-if="buscaJsonDados" class="small text-muted mt-1">
                                        {{ contarOcorrenciasJson(item.js_data, buscaJsonDados) }} ocorrência(s) encontrada(s)
                                    </div>
                                </div>
                                <pre class="bg-light p-2 rounded small" style="max-height: 400px; overflow-y: scroll;" v-html="formatarJsonComBusca(item.js_data, buscaJsonDados)"></pre>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import ConfigMainTitle from "../../cadastros/shared/ConfigMainTitle.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzPeriodo from "../../shared/forms/AzPeriodo.vue";
import AzSubmit from "../../util/AzSubmit.vue";

export default {
    components: {
        ConfigMainTitle,
        AzInput,
        AzPeriodo,
        AzSubmit,
    },

    data() {
        return {
            dados: {
                data: [],
                last_page: 0,
            },
            lista: [],
            filtros: {
                page: 1,
                size: 20,
                periodo: '',
                inicio: null,
                fim: null,
            },
            bloqueia_sync_periodo: true,
            item: null,
            execucao: {
                dt_execucao: null,
            },
            buscaJsonDados: "",
            validate: false,
        };
    },

    computed: {
        lista_filtrada: function () {
            return this.lista || [];
        },
    },

    methods: {
        carregar(page = 1) {
            this.filtros.page = page;

            this.$util.load(this, {
                service: "promedsys_logs",
                parms: {
                    page: this.filtros.page,
                    size: this.filtros.size,
                    dt_inicio: this.filtros.inicio,
                    dt_fim: this.filtros.fim,
                },
                loadTo: (res) => {
                    const payload = this.normalizar_paginacao(res);
                    this.dados = payload.dados;
                    this.lista = payload.lista;

                    if (page > 1 && this.dados && this.dados.last_page && page > this.dados.last_page) {
                        this.carregar(1);
                    }
                },
            });
        },

        recarregar(page = 1) {
            this.carregar(page);
        },

        sincronizarPeriodo() {
            if (this.bloqueia_sync_periodo) return;
            this.recarregar(1);
        },

        normalizar_paginacao(res) {
            if (Array.isArray(res)) {
                return {
                    dados: {
                        data: res,
                        last_page: 1,
                    },
                    lista: res,
                };
            }

            if (res && Array.isArray(res.data)) {
                return {
                    dados: res,
                    lista: res.data,
                };
            }

            if (res && res.data && Array.isArray(res.data.data)) {
                return {
                    dados: res.data,
                    lista: res.data.data,
                };
            }

            if (res && res.data && res.data.lista && Array.isArray(res.data.lista.data)) {
                return {
                    dados: res.data.lista,
                    lista: res.data.lista.data,
                };
            }

            return {
                dados: {
                    data: [],
                    last_page: 0,
                },
                lista: [],
            };
        },

        abrir_modal_executar() {
            this.validate = false;
            this.execucao = { dt_execucao: null };
            this.$nextTick(() => {
                $("#modalExecutarPromedSys").modal("show");
            });
        },

        confirmar_execucao() {
            this.validate = true;
            if (!this.execucao.dt_execucao) return;

            this.$util.atualizar(this, {
                service: "campanhas",
                func: "executar_agora_promedsys",
                modal: "modalExecutarPromedSys",
                dados: {
                    dt_ultima_execucao: this.execucao.dt_execucao,
                },
                toast: true,
                msg: "Execução iniciada com sucesso.",
                callback: () => {
                    this.carregar();
                },
            });
        },

        editar_log(log) {
            this.item = log;
            this.buscaJsonDados = "";
            this.$nextTick(() => {
                $("#modalPromedSys").modal("show");
            });
        },

        formatarData(valor) {
            if (!valor) return "-";
            const d = new Date(valor.replace(" ", "T"));
            if (isNaN(d)) return valor;
            return d.toLocaleString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        },

        formatarJson(valor) {
            if (!valor) return "-";
            try {
                const obj = typeof valor === "string" ? JSON.parse(valor) : valor;
                return JSON.stringify(obj, null, 2);
            } catch {
                return valor;
            }
        },

        escapeHtml(valor) {
            if (valor == null) return "";

            return String(valor)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;");
        },

        escaparRegex(valor) {
            return valor.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        },

        formatarJsonComBusca(valor, busca) {
            const jsonFormatado = this.formatarJson(valor);
            const jsonEscapado = this.escapeHtml(jsonFormatado);

            if (!busca) return jsonEscapado;

            const regex = new RegExp(`(${this.escaparRegex(this.escapeHtml(busca))})`, "gi");
            return jsonEscapado.replace(regex, '<mark class="px-1">$1</mark>');
        },

        contarOcorrenciasJson(valor, busca) {
            if (!busca) return 0;

            const jsonFormatado = this.formatarJson(valor);
            const ocorrencias = jsonFormatado.match(new RegExp(this.escaparRegex(busca), "gi"));

            return ocorrencias ? ocorrencias.length : 0;
        },

        formatarDataFiltro(data) {
            if (!data) return null;
            const ano = data.getFullYear();
            const mes = String(data.getMonth() + 1).padStart(2, "0");
            const dia = String(data.getDate()).padStart(2, "0");
            return `${ano}-${mes}-${dia}`;
        },

        definirPeriodoPadrao() {
            const hoje = new Date();
            const inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
            const fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

            this.filtros = {
                ...this.filtros,
                inicio: this.formatarDataFiltro(inicio),
                fim: this.formatarDataFiltro(fim),
            };
        },
    },

    mounted() {
        this.definirPeriodoPadrao();
        this.$nextTick(() => {
            this.bloqueia_sync_periodo = false;
            this.carregar(1);
        });

        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros" },
            { name: "Logs Promedsys", path: "" },
        ];

        this.$store.commit("setBreadcrumb", this.breadcrumb);
    },
};
</script>
